import cn from 'classnames';
import orientationStyles from '../styles/orientation.module.css';
import { UserStudio } from '../features/api/apiSlice';

interface PlayerClassesOptions {
  isMobile?: boolean;
}

interface StreamOrientationUtils {
  isHorizontal: boolean;
  getPlayerWrapperClasses: (baseClass: string, options?: PlayerClassesOptions) => string;
  getPlayerClasses: (baseClass: string, options?: PlayerClassesOptions) => string;
  getStreamLayoutPageClasses: (baseClass: string) => string;
  getStreamLayoutPlayerClasses: (baseClass: string) => string;
}

export const getStreamOrientation = (studio: UserStudio | undefined): StreamOrientationUtils => {
  const isHorizontal = studio?.orientation === 'landscape';

  const getPlayerWrapperClasses = (baseClass: string, { isMobile }: PlayerClassesOptions = {}) => {
    const containerClass = isMobile ? orientationStyles['mobile-player-container'] : orientationStyles['player-wrapper'];
    const horizontalClass = isMobile ? orientationStyles['mobile-player-container_horizontal'] : orientationStyles['player-wrapper_horizontal'];
    const verticalClass = isMobile ? orientationStyles['mobile-player-container_vertical'] : orientationStyles['player-wrapper_vertical'];

    return cn(
      baseClass,
      containerClass,
      {
        [horizontalClass]: isHorizontal,
        [verticalClass]: !isHorizontal
      }
    );
  };

  const getPlayerClasses = (baseClass: string, { isMobile }: PlayerClassesOptions = {}) => {
    const playerClass = isMobile ? orientationStyles['mobile-player'] : orientationStyles['player'];
    const horizontalClass = isMobile ? orientationStyles['mobile-player_horizontal'] : orientationStyles['player_horizontal'];
    const verticalClass = isMobile ? orientationStyles['mobile-player_vertical'] : orientationStyles['player_vertical'];

    return cn(
      baseClass,
      playerClass,
      {
        [horizontalClass]: isHorizontal,
        [verticalClass]: !isHorizontal
      }
    );
  };

  const getStreamLayoutPageClasses = (baseClass: string) => {
    return cn(
      baseClass,
      {
        [orientationStyles['stream-layout-page_horizontal']]: isHorizontal,
        [orientationStyles['stream-layout-page_vertical']]: !isHorizontal
      }
    );
  };

  const getStreamLayoutPlayerClasses = (baseClass: string) => {
    return cn(
      baseClass,
      {
        [orientationStyles['stream-layout-page__player_horizontal']]: isHorizontal,
        [orientationStyles['stream-layout-page__player_vertical']]: !isHorizontal
      }
    );
  };

  return {
    isHorizontal,
    getPlayerWrapperClasses,
    getPlayerClasses,
    getStreamLayoutPageClasses,
    getStreamLayoutPlayerClasses
  };
};